import { api } from "./client";

/** Per piece of work: learners who handed it in, and learners with a released judgement. */
export interface CourseworkCount { assignment_id: string; handed_in: number; released: number }

/** Owner ruling 1: administration reads coursework as counts only, never a judgement. */
export const courseworkCountsApi = {
  get: (courseId: string) => api.get<{ course_id: string; counts: CourseworkCount[] }>(`/courses/${courseId}/coursework-counts`),
};
